import moment from 'moment';

const SubHeader = ({fy_list, setDivisionNumber, handlePageTrigger  }) => {
    const handleFinancialYearChange = async (e) => {
        const val = e.target.value;
        localStorage.setItem("globalDateId", val);
        handlePageTrigger();
    };
    const fyId = localStorage.getItem('globalDateId');
    return (
        <div className="budget_analysis border position-relative" style={{backgroundColor: '#fff', padding: '10px 16px'}}>
        <h1 className='p-0 m-0'>Financial Year</h1>
        <div className="d-flex gap-8px justify-content-start align-items-center" style={{width:"13%"}} >
            <select 
            id="financial_year"
            name="financial_year_id"
            onChange={handleFinancialYearChange}
            style={{ width: "100%" }}
            >
                <option value="">---select year---</option>
                {fy_list.map((fy) => {
                const currentMonth = moment().month() + 1;
                const selectedYear = (!fyId) ? currentMonth >= 4 ? fy.start_year : fy.end_year : fyId;
                return (
                <option 
                    value={fy.id}
                    key={fy.id}
                    selected={ Number(fyId) === Number(fy.id) ||selectedYear === moment().format("YYYY")}
                >
                    {fy.year}
                </option>
                );
            })}
            </select>
        </div>

        <p className='position-absolute end-0 pe-3 translate-50 fs-12px'>All value in Indian
            <select name="rupe" id="rupe" style={{width:"fit-content"}} className='bg-transparent border-0 text-prime-100' onChange={(e)=>setDivisionNumber(e.target.value)} disabled={true}>
              <option value="1" selected> Rupees</option>
              <option value="1000"> Thousands Rupees </option>
              <option value="100000"> Lakhs Rupees </option>
              <option value="10000000"> Crores Rupees </option>
            </select>
        </p>
        </div>
    )
}

export default SubHeader;